import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DistanceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DistanceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.6217 20C12.8958 20 11.4914 18.5955 11.4914 16.8697V7.33268C11.4914 6.11081 10.4972 5.11663 9.2753 5.11663C8.05343 5.11663 7.05969 6.11081 7.05969 7.33268V18.9491C7.05969 19.2018 6.85523 19.4063 6.60255 19.4063C6.34987 19.4063 6.14541 19.2018 6.14541 18.9491V7.33268C6.14541 5.6068 7.54941 4.20235 9.2753 4.20235C11.0012 4.20235 12.4056 5.6068 12.4056 7.33268V16.8697C12.4056 18.0915 13.3998 19.0857 14.6217 19.0857C15.8436 19.0857 16.8377 18.0915 16.8377 16.8697V5.58225C16.8377 5.32957 17.0422 5.12511 17.2949 5.12511C17.5476 5.12511 17.752 5.32957 17.752 5.58225V16.8697C17.752 18.5955 16.3476 20 14.6217 20Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.2892 8.35162C18.4909 8.35162 19.465 7.37748 19.465 6.17581C19.465 4.97414 18.4909 4 17.2892 4C16.0876 4 15.1134 4.97414 15.1134 6.17581C15.1134 7.37748 16.0876 8.35162 17.2892 8.35162Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.59854 19.7027C6.47666 19.7027 6.36015 19.654 6.27443 19.5679L4.66819 17.9523C4.49007 17.7732 4.49096 17.4839 4.66998 17.3058C4.84854 17.1268 5.13783 17.1286 5.3164 17.3076L6.59362 18.5924L7.82843 17.3125C8.00432 17.1308 8.29361 17.1259 8.47486 17.3009C8.65655 17.4764 8.66191 17.7656 8.48647 17.9473L6.92755 19.5629C6.84139 19.6522 6.72755 19.7027 6.59854 19.7027Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DistanceIcon;
